import { bff, createBFFHandlers } from '~/framework/bff';
import { z } from 'zod';
import { getServerSideMonolithClient } from '~/framework';
import { ACCOUNT_TYPES, createUsersByEmail, CreateUsersByEmailOptions } from '~/monolith-api';

export type { CreateUsersByEmailOptions };

const createUsersByEmailSchema = z.object({
   emails: z.array(z.string()),
   accountType: z.enum(ACCOUNT_TYPES),
});

export default createBFFHandlers({
   post: async (req, res) => {
      const { emails, accountType } = createUsersByEmailSchema.parse(req.body);
      const monolithClient = getServerSideMonolithClient(req);
      const result = await createUsersByEmail({
         emails: emails,
         accountType: accountType,
         apiClient: monolithClient,
      });
      res.status(201).json(result);
   },
});

export const createUsersByEmailFromClient = ({
   emails,
   accountType,
}: Pick<CreateUsersByEmailOptions, 'emails' | 'accountType'>): ReturnType<
   typeof createUsersByEmail
> => {
   return bff()
      .post('/users/createUsersByEmail', {
         emails,
         accountType,
      })
      .then(response => response.data);
};
